/* eslint-disable react/jsx-indent */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import AddFacilitators from '../../assets/invite/add-facilitators.png';
import SubFacilitators from '../../assets/invite/sub-facilitators.png';
import CardComponent from '../../components/card/card.component';
import ShowToast from '../../components/ShowToast';
import TitleComponent from '../../components/title/title.component';
import {
  useAddProgram,
  useUserSearch,
  useGetAllFacilitator,
  useUpdateFacilitator,
} from '../../services';
import { useProgramStore, useUserStore, useFacilitatorStore } from '../../store';
import { GameAccessEnum, useDebounce } from '../../utils';
import styles from './invite.module.scss';
import Loader from '../../components/Loader';

const InvitePage = ({ history }) => {
  const [facilitator, setFacilitator] = useState([]);
  const [selected, setSelected] = useState();
  const [search, setSearch] = useState();
  const [users, setUsers] = useState([{ id: 'test', name: 'test', value: 'test', label: 'test' }]);
  const { action } = useParams();
  useGetAllFacilitator();
  const facilitators = useFacilitatorStore().facilitatorsList;

  const newArray = [];

  facilitators.map((facil) =>
    facil.is_Certified ? newArray.push({ ...facil, label: facil.email, value: facil.id }) : null
  );

  const program = useProgramStore((s) => s.program);
  const setProgram = useProgramStore((s) => s.setProgram);
  const user = useUserStore((s) => s.user);

  const data = useDebounce(search, 1000);
  const query = useUserSearch(data, setUsers);

  const addProgram = useAddProgram();
  const updateFacilitator = useUpdateFacilitator();

  useLayoutEffect(() => {
    if (!program.name) {
      history.push('/design/add/new');
    }
  }, [history, program]);

  useEffect(() => {
    if (program.facilitatorids) {
      const createFacilitatorsFromIds = [];
      program.facilitatorids.map((facilId) => {
        const index = newArray.findIndex((facil) => facil.id === facilId);
        if (index > -1) {
          createFacilitatorsFromIds.push({
            label: `${newArray[index].first_name} ${newArray[index].last_name} (${newArray[index].email})`,
            value: newArray[index].id,
          });
        }
        return null;
      });

      setProgram({
        facilitators: createFacilitatorsFromIds,
      });

      setFacilitator(createFacilitatorsFromIds);
    } else {
      setFacilitator([...program.facilitators]);
    }
  }, [program.facilitatorids, facilitators]);

  const onNextClick = () => {
    if (action === 'edit') {
      if (program.fac_count < facilitator.length)
        return ShowToast('Facilitator are more than game_access', 'error');

      const dataa = { id: program.id, facilitators: facilitator };

      updateFacilitator.mutate(dataa);
    } else {
      const facIds = program.facilitators.map((d) => d.value);
      if (facIds.length < 1) return ShowToast('Please add atleast one facilitator', 'error');

      if (facIds.length > program.fac_count)
        return ShowToast('Facilitator are more than game_access', 'error');
      return addProgram.mutate({
        name: program.name,
        description: program.description,
        date: program.date,
        time: program.time,
        game_access: program.game_access,
        facilitators: facIds,
        timezone: program.timezone,
        fac_count: program.fac_count.toString(),
      });
    }
    return null;
  };

  const addSelected = () => {
    const index = program.facilitators.findIndex((d) => d.value === selected.value);
    if (index === -1) {
      setProgram({
        facilitators: [...program.facilitators, selected],
      });

      setFacilitator([...program.facilitators, selected]);
    } else {
      ShowToast('Facilitator already added.', 'info');
    }
    setSelected('');
  };

  return (
    <>
      {addProgram.isLoading && <Loader />}
      <div className={`w-75 pt-3   ${styles.title}`}>
        <TitleComponent
          title="Home/ New program"
          heading="Invite"
          subtitle="Facilitators that will co-facilitate with you"
        />
      </div>

      <div className={`container ${styles['box-shadow']}`}>
        <CardComponent>
          <>
            <h5 className="font-weight-bold p-2"> Program Details </h5>
            <div className="ml-4">
              <h6>
                Program name :<strong>{program.name}</strong>
              </h6>

              <h6>
                Scheduled date and time :
                <strong>{`${dayjs(program.date).format('DD-MMM-YYYY')}, ${program.time}`}</strong>
                <strong>{program.timezone}`</strong>
              </h6>

              <h6>
                Game Access :
                <strong>
                  {program.game_access === GameAccessEnum.HALF ? 'HALF DAY' : 'FULL DAY'}
                </strong>
              </h6>
              <h6>
                Number of Game Accesses :<strong>{program.fac_count}</strong>
              </h6>
            </div>

            <div className="border m-3" />

            <strong> Add facilitators to this program</strong>

            <div className="container">
              <div className="row">
                <div className="col">
                  {facilitator
                    ? facilitator.map((f, i) => (
                        <div className="row" style={{ marginBottom: '10px' }} key={f.value}>
                          <div className="col">Facilitator {i + 1}</div>
                          <div className="col-7">
                            <b>{f.label}</b>
                          </div>
                          <div className="col">
                            <button
                              type="button"
                              className={`btn ${styles['edit-border']}`}
                              // disabled={f.value === user.id}
                              onClick={() => {
                                setProgram({
                                  facilitators: program.facilitators.filter(
                                    (p) => p.value !== f.value
                                  ),
                                });
                                setFacilitator(facilitator.filter((p) => p.value !== f.value));
                              }}>
                              <img src={SubFacilitators} alt="edit-icon" />
                            </button>
                          </div>
                        </div>
                      ))
                    : null}

                  {/* {program.facilitators.length < program.fac_count && ( */}
                  <div className="row" style={{ marginBottom: '10px' }}>
                    <div className="col">Add Facilitator</div>
                    <div className="col-7">
                      <Select
                        options={newArray}
                        isLoading={query.isLoading}
                        isClearable
                        isSearchable
                        onInputChange={(v) => setSearch(v)}
                        onChange={(v) =>
                          v
                            ? setSelected({
                                label: `${v.first_name} ${v.last_name} (${v.email})`,
                                value: v.id,
                              })
                            : null
                        }
                      />
                    </div>

                    <div className="col">
                      <button
                        disabled={selected ? 0 : 1}
                        type="button"
                        className={`btn ${styles['edit-border']}`}
                        onClick={addSelected}>
                        <img src={AddFacilitators} alt="edit-icon" />
                      </button>
                    </div>
                  </div>
                  {/* )} */}
                </div>
                <div className="col-4">
                  <strong>Please note: </strong>
                  <p>
                    You will not be able to invite facilitators that are not certified to run
                    Evivve- The Leadership Game
                  </p>
                </div>
              </div>
            </div>

            <div className="p-3 float-right">
              <button
                type="button"
                onClick={onNextClick}
                className="btn btn-secondary w-100 ml-3 mr-3">
                {action === 'edit' ? 'Update' : 'Finish'}
              </button>
            </div>
          </>
        </CardComponent>
      </div>
    </>
  );
};
InvitePage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};
export default InvitePage;
